import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import isEqual from 'lodash/isEqual';

import ScopeContext from 'ia-react-core/~/components/redux/_ScopeContext/ScopeContext';

const useStoreSubscription = <Result, State = unknown>(callback: (state: State) => Result) => {
  const { store } = useContext(ScopeContext);

  const callbackWithState = useCallback(() => {
    const state = store.getState();
    return callback(state);
  }, [callback, store]);

  const [result, setResult] = useState(callbackWithState);

  const resultRef = useRef(result);

  const handleUpdate = useCallback(() => {
    const newResult = callbackWithState();
    if (!isEqual(resultRef.current, newResult)) {
      resultRef.current = newResult;
      setResult(newResult);
    }
  }, [callbackWithState]);

  useEffect(() => {
    // Handle changes that could have happened between first render and useEffect
    handleUpdate();
    return store.subscribe(handleUpdate);
  }, [handleUpdate, store]);

  return result;
};

export default useStoreSubscription;
